import { useCallback } from "react";

import { Dashboard } from "api/model/dashboard/Dashboard";
import { useNavigate } from "react-router-dom";

const useTabNavigation = (dashboard: Dashboard, isMobile: boolean) => {
  const navigate = useNavigate();

  const handleTabChange = useCallback(
    (tabUUID: string, e?: { originalEvent?: Event | React.SyntheticEvent }) => {
      const selectedIndex = dashboard.dashboardTabsJs.findIndex(tab => tab.uuid === tabUUID);

      const isCtrlOrMetaPressed =
        e?.originalEvent &&
        ("ctrlKey" in e.originalEvent || "metaKey" in e.originalEvent) &&
        ((e.originalEvent as MouseEvent).ctrlKey || (e.originalEvent as MouseEvent).metaKey);

      if (!isMobile && isCtrlOrMetaPressed) {
        const newTabUrl = `${window.location.pathname}/#/dashboard/${dashboard.id}/tab/${selectedIndex}`;
        window.open(newTabUrl, "_blank");
      } else {
        navigate(`/dashboard/${dashboard.id}/tab/${selectedIndex}`);
      }
    },
    [dashboard.dashboardTabsJs, dashboard.id, isMobile, navigate]
  );

  return { handleTabChange };
};

export default useTabNavigation;
